<template>
    <div>
        <!-- 问题反馈 -->
        <div class="feedbac">
            <div class="title">问题反馈 <span>*非常感谢您能抽出宝贵时间为我们提出意见和反馈，我们会极力改正做到更好*</span></div>
            <div class="from">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="问题标题：" prop="name">
                        <el-input v-model="ruleForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="问题内容：" prop="desc">
                        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
                    </el-form-item>
                    <el-form-item label="问题图片：">
                        <!-- <el-upload
                            accept="image/png,image/gif,image/jpeg,image/bmp/"
                            action="https://jsonplaceholder.typicode.com/posts/"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUpload">
                            <i class="el-icon-plus"></i>
                        </el-upload> -->
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="connection">
                <span class="phone">联系电话 <span>（服务时间：周一至周六下午8:00-15:30）</span></span>
                <div class="number clearfix">
                    <span class="fl">电脑平板专线：400-680-1980</span><span class="fr">电脑平板专线：400-680-1980</span>
                </div>
            </div>
        </div>
        <div class="history">
            <div class="title">反馈历史</div>
            <div class="table">
                <el-table
                :data="tableData"
                style="width: 100%">
                    <el-table-column
                        prop="date"
                        label="反馈时间">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="标题">
                    </el-table-column>
                    <el-table-column
                        prop="address"
                        label="回答日期">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="详情"
                        width="100">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                    </template>
                    </el-table-column>
                </el-table>
            </div>
            <pagination :listconhttpnum="listconhttpnum"></pagination>
        </div>
    </div>
</template>
<script>
import pagination from '../resource/pagination'
export default {
    components:{
        pagination
    },
    data() {
        return {
            ruleForm: {
                name: '',
                desc:'',
            },
            rules: {
                name: [
                    { required: true, message: '请输入问题标题', trigger: 'blur' },
                ],
                desc: [
                    { required: true, message: '请填写问题内容', trigger: 'blur' }
                ]
            },
            tableData: [{
                date: '2021-04-12 14:25:35',
                name: '上传方式',
                address: '2021-04-12 14:25:35',
            }],
            listconhttpnum:10
        }
    },
    watch: {},
    mounted() {},
    methods: {
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        beforeUpload(file){
            // console.log(file);
            // var filename = file.name;
            // var getSuffix = function (filename) {
            //     var pos = filename.lastIndexOf(".");
            //     var suffix = '';
            //     if (pos != -1) {
            //         suffix = filename.substring(pos);
            //     }
            //     return suffix;
            // }
            // filename = new Date().getTime() +  Math.ceil(Math.random()*10000) + getSuffix(filename);
            // var _self = this;
            // var formData = new FormData();
            // //注意formData里append添加的键的大小写
            // formData.append('key', _self.aliyunOssToken.dir +'space/'+ filename); //存储在oss的文件路径
            // formData.append('OSSAccessKeyId', _self.aliyunOssToken.accessid); //accessKeyId
            // formData.append('policy', _self.aliyunOssToken.policy); //policy
            // formData.append('Signature', _self.aliyunOssToken.signature); //签名
            // //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
            // formData.append('callback', _self.aliyunOssToken.callback); //policy
            // formData.append("file", file);
            // formData.append('success_action_status', 200); //成功后返回的操作码
            // var url = _self.aliyunOssToken.host;
            // $.ajax({
            //     url: url,
            //     type: 'POST',
            //     data: formData,
            //     cache: false,
            //     contentType: false,
            //     processData: false,
            //     success: function (data) {            
            //         console.log(data);
            //     },
            //     error: function (data) {
            //     }
            // });
            return false;
        },
        // 提交
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                alert('submit!');
            } else {
                // console.log('error submit!!');
                return false;
            }
            });
        },

        // 历史查看
        handleClick(index){
            // console.log(index);
        },
    }
}
</script>

<style lang='less' scoped>
.feedbac{
    padding: 30px 50px;
    background-color: #fff;
    .title{
        font-size: 16px;
        line-height: 30px;
        span{
            display: inline-block;
            font-size: 12px;
            color: #3b8bfd;
            margin-left: 15px;
        }
    }
    .from{
        padding: 20px 0;
    }
    .connection{
        padding-top: 20px;
        border-top: 1px solid #b4b2b2;
        .phone{
            font-size: 16px;
            line-height: 30px;
            span{
                display: inline-block;
                font-size: 12px;
                color: #b4b2b2;
                margin-left: 15px;
            }
        }
        .number{
            line-height: 50px;
            padding: 0 90px;
            span{
                display: inline-block;
                font-size: 14px;
                color: #555555;
            }
        }
    }
}
.history{
    margin-top: 20px;
    padding: 30px 50px;
    background-color: #fff;
    .table{
        margin-top: 20px;
        min-height: 300px;
    }
    /deep/ .el-table th{
        background-color: #eef7fe;
        color: #000;
    }
}
</style>
